import useAuthStore from "../stores/useAuthStore";

/**
 * Resolves the current till's cwrTillID for tillId-scoped queries.
 *
 * BUG-1612's repairTillValue() only runs at setTillData() time, so anything
 * that later calls setTillValue({}) directly (Till.js does this on several
 * paths — error handling, re-registration, auto-relogin) wipes cwr_till_id
 * again without touching tillData. A tillId-scoped GraphQL query then filters
 * on undefined and silently returns nothing — no error, just empty results
 * (this is what left products/categories empty on first login while sale types,
 * which filter by cwrPcatalogueId, synced fine).
 *
 * tillData.tillAccess.cwrTill.cwrTillID carries the same identifier and is
 * populated whenever tillData itself is usable, so prefer it and fall back to
 * the store's tillValue only if tillData somehow lacks it.
 *
 * Lives here rather than as a named export of useAuthStore so the ~27 test
 * files that `vi.mock` that store with a default-only factory keep working —
 * this reads through the store's default export, which those mocks provide.
 */
export const getCurrentTillId = () => {
  const { tillData, tillValue } = useAuthStore.getState();
  return tillData?.tillAccess?.cwrTill?.cwrTillID || tillValue?.cwr_till_id || null;
};
